import _extends from '@babel/runtime/helpers/esm/extends';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Animator } from '@paypalcorp/pp-react-animator';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { FocusOn } from 'react-focus-on';
import { IconButton } from '@paypalcorp/pp-react-icon-button';
import { V2CloseIcon, CloseIcon } from '@paypalcorp/pp-react-icons';
import { useTheme } from '@paypalcorp/pp-react-theme';
import clsx from 'clsx';
import '../__generated__/styles/sheet.css';
import { uniqueId } from '@paypalcorp/pp-react-utils';

var styles = {"ppvx_modal--container_middle":"ppvx_modal--container_middle___1-15-4","ppvx_modal--container_bottom":"ppvx_modal--container_bottom___1-15-4","ppvx_modal":"ppvx_modal___1-15-4","ppvx_modal--overpanel":"ppvx_modal--overpanel___1-15-4","ppvx_modal--sheet":"ppvx_modal--sheet___1-15-4","ppvx_modal-backdrop":"ppvx_modal-backdrop___1-15-4","ppvx_modal-backdrop--show":"ppvx_modal-backdrop--show___1-15-4","ppvx_scrim":"ppvx_scrim___1-15-4","ppvx_scrim--show":"ppvx_scrim--show___1-15-4","ppvx_modal__contents":"ppvx_modal__contents___1-15-4","ppvx_modal-header":"ppvx_modal-header___1-15-4","ppvx_modal__contents--no-padding":"ppvx_modal__contents--no-padding___1-15-4","ppvx_modal__contents--center":"ppvx_modal__contents--center___1-15-4","ppvx_modal__screenreader":"ppvx_modal__screenreader___1-15-4","ppvx_modal-header__close":"ppvx_modal-header__close___1-15-4","ppvx_modal-header__action":"ppvx_modal-header__action___1-15-4","ppvx_modal-header--gripper":"ppvx_modal-header--gripper___1-15-4","ppvx_modal-header--divider":"ppvx_modal-header--divider___1-15-4","ppvx_modal-header--scrolled":"ppvx_modal-header--scrolled___1-15-4","ppvx_modal-header__title":"ppvx_modal-header__title___1-15-4","ppvx_modal-header__work-area":"ppvx_modal-header__work-area___1-15-4","ppvx_modal__contents--close":"ppvx_modal__contents--close___1-15-4","ppvx_modal-header__close-btn":"ppvx_modal-header__close-btn___1-15-4","ppvx_modal-content__title":"ppvx_modal-content__title___1-15-4","ppvx_modal-header--no-logo":"ppvx_modal-header--no-logo___1-15-4","ppvx_modal-footer":"ppvx_modal-footer___1-15-4","ppvx_modal-footer--scrolled":"ppvx_modal-footer--scrolled___1-15-4","ppvx_modal-footer--align_center":"ppvx_modal-footer--align_center___1-15-4","ppvx_modal-footer--align_right":"ppvx_modal-footer--align_right___1-15-4","ppvx_visible-only-in-context":"ppvx_visible-only-in-context___1-15-4","ppvx_modal--sheet--height_90":"ppvx_modal--sheet--height_90___1-15-4","ppvx_modal-header__close-btn--svg":"ppvx_modal-header__close-btn--svg___1-15-4","ppvx--v2":"ppvx--v2___1-15-4","ppvx--v1":"ppvx--v1___1-15-4"};

var _excluded = ["requestClose", "onBeforeClose", "className", "isHidden", "center", "noPadding", "closeButtonLabel", "noCloseButton", "closeButtonProps", "divider", "hideTitle", "mobileFixedHeight", "title", "id", "action", "headerContents", "footerContents", "footerAlign", "children", "returnFocusToTrigger", "headerClassName", "contentContainerRef", "containerClassName", "wrapperClassName", "footerClassName", "skipFormFocus", "theme", "contentScrollTop", "onContentScroll"];

var closeSheet = function () {
  return true;
}; // eslint-disable-next-line complexity


var SheetComponent = function (_ref) {
  var _clsx, _clsx3, _clsx4, _clsx5;

  var requestClose = _ref.requestClose,
      _ref$onBeforeClose = _ref.onBeforeClose,
      onBeforeClose = _ref$onBeforeClose === void 0 ? closeSheet : _ref$onBeforeClose,
      className = _ref.className,
      isHidden = _ref.isHidden,
      center = _ref.center,
      noPadding = _ref.noPadding,
      _ref$closeButtonLabel = _ref.closeButtonLabel,
      closeButtonLabel = _ref$closeButtonLabel === void 0 ? 'close sheet' : _ref$closeButtonLabel,
      noCloseButton = _ref.noCloseButton,
      _ref$closeButtonProps = _ref.closeButtonProps,
      closeButtonProps = _ref$closeButtonProps === void 0 ? {} : _ref$closeButtonProps,
      divider = _ref.divider,
      hideTitle = _ref.hideTitle,
      mobileFixedHeight = _ref.mobileFixedHeight,
      title = _ref.title,
      id = _ref.id,
      action = _ref.action,
      headerContents = _ref.headerContents,
      footerContents = _ref.footerContents,
      footerAlign = _ref.footerAlign,
      children = _ref.children,
      _ref$returnFocusToTri = _ref.returnFocusToTrigger,
      returnFocusToTrigger = _ref$returnFocusToTri === void 0 ? true : _ref$returnFocusToTri,
      headerClassName = _ref.headerClassName,
      contentContainerRef = _ref.contentContainerRef,
      containerClassName = _ref.containerClassName,
      wrapperClassName = _ref.wrapperClassName,
      footerClassName = _ref.footerClassName,
      skipFormFocus = _ref.skipFormFocus,
      theme = _ref.theme,
      _ref$contentScrollTop = _ref.contentScrollTop,
      contentScrollTop = _ref$contentScrollTop === void 0 ? 0 : _ref$contentScrollTop,
      onContentScroll = _ref.onContentScroll,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      headerScroll = _useState2[0],
      setHeaderScroll = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      footerScroll = _useState4[0],
      setFooterScroll = _useState4[1];

  var sheetRef = useRef();
  var closeButtonRef = useRef();
  var actionZoneRef = useRef();
  var refContent = useRef();
  var contentRef = contentContainerRef || refContent;
  var headerContentRef = useRef();
  var startX;
  var startY;

  var _theme = useTheme('Sheet', theme);

  if (_theme !== 'v2') {
    console.warn('Sheet 1.0 styles are deprecated. Use Sheet 2.0 styles and refer to our Migration Guide on how to use 2.0 styles/components.');
  }

  var idBase = id !== null && id !== void 0 ? id : uniqueId();
  var showHeader = !!action || !noCloseButton || !hideTitle || !!headerContents; // jest has no way to test things like scrollTop or scrollHeight --BCC

  /* istanbul ignore next */

  var scrollCheck = function () {
    if (contentRef && contentRef.current) {
      var contents = contentRef.current;
      var newHeaderScroll = contents.scrollTop !== 0;

      if (newHeaderScroll !== headerScroll) {
        setHeaderScroll(newHeaderScroll);
      } // Footer is optional, may not be one to watch for!


      if (footerContents) {
        // Have we scrolled to the bottom?
        var newFooterScroll = contents.scrollTop + contents.offsetHeight !== contents.scrollHeight;

        if (newFooterScroll !== footerScroll) {
          setFooterScroll(newFooterScroll);
        }
      }
    }
  };

  /* istanbul ignore next */
  var setFixedHeight = function () {
    var fixedHeight = window.innerHeight * 0.9;
    var sheetEl = sheetRef.current;

    if (sheetEl) {
      if (mobileFixedHeight === '90') {
        sheetEl.style.height = "".concat(fixedHeight, "px");
      } else {
        sheetEl.style.maxHeight = "".concat(fixedHeight, "px");
      }
    }
  };

  useEffect(function () {
    if (!isHidden) {
      scrollCheck(); // istanbul ignore next

      if (window && window.setTimeout) {
        // istanbul ignore next
        window.setTimeout(function () {
          // HACK ALERT! react-on-focus fails at setting the focus
          // if we are transitioning opacity. This causes the sheet
          // to set the focus on the close button but NOT indicate
          // that fact to the user either visually or in the screen reader
          // So timeOut was needed
          var focused = false; // For combobox input on sheet header

          if (headerContentRef && headerContentRef.current) {
            //@ts-ignore
            var formElement = headerContentRef.current.querySelector('input');

            if (formElement) {
              formElement.focus();
              focused = true;
            }
          } // For Forms


          if (!focused && !skipFormFocus && contentRef && contentRef.current) {
            //@ts-ignore
            var focusableEls = contentRef.current.querySelectorAll('a, button, textarea, input, select');

            if (focusableEls.length > 0) {
              focusableEls[0].focus();
              focused = true;
            }
          } // Otherwise focus on action item or close button


          if (!focused && showHeader) {
            if (action && actionZoneRef && actionZoneRef.current) {
              //@ts-ignore
              var focusableActionEl = actionZoneRef.current.querySelectorAll('a, button, select');

              if (focusableActionEl.length > 0) {
                focusableActionEl[0].focus();
              }
            } else {
              var closeButtonCurrent = closeButtonRef.current;

              if (closeButtonCurrent) {
                //@ts-ignore
                closeButtonCurrent.focus();
              }
            }
          }
        }, 500);
      }
      /* istanbul ignore next */


      var isTouchDevice = 'ontouchstart' in window || navigator.msMaxTouchPoints;
      /* istanbul ignore next */

      if (isTouchDevice && window.innerHeight) {
        setFixedHeight();
        window.addEventListener('resize', setFixedHeight, false);
      }
    }

    return function () {
      window.removeEventListener('resize', setFixedHeight, false);
    };
  }, [isHidden]);
  useEffect(function () {
    if (!isHidden && contentRef.current) {
      var contents = contentRef.current;
      contents.scrollTop = contentScrollTop;
    }
  }, [contentScrollTop, isHidden]);
  /* istanbul ignore next */

  var wrapperClasses = clsx(styles.ppvx_scrim, (_clsx = {}, _defineProperty(_clsx, styles['ppvx_scrim--show'], !isHidden), _defineProperty(_clsx, styles["ppvx--".concat(_theme)], _theme), _clsx), wrapperClassName);
  var classes = clsx(styles.ppvx_modal, styles['ppvx_modal--sheet'], _defineProperty({}, styles["ppvx_modal--sheet--height_".concat(mobileFixedHeight)], mobileFixedHeight), containerClassName);
  var contentClasses = clsx(styles.ppvx_modal__contents, (_clsx3 = {}, _defineProperty(_clsx3, styles['ppvx_modal__contents--center'], center), _defineProperty(_clsx3, styles['ppvx_modal__contents--no-padding'], noPadding), _clsx3), className);
  var ariaHidden = isHidden ? 'true' : 'false';

  var handleClose = function (evt, closedBy) {
    var okToClose = onBeforeClose(closedBy);

    if (okToClose) {
      requestClose(evt, closedBy);
      startX = null;
      startY = null;
    }
  };

  var closeButtonTag = noCloseButton ? null : /*#__PURE__*/React.createElement(IconButton, _extends({
    svgIconComponent: _theme === 'v2' ? V2CloseIcon : CloseIcon,
    "aria-haspopup": "dialog",
    tabIndex: 0,
    onClick: function onClick(evt) {
      handleClose(evt, 'closeButton');
    },
    ref: closeButtonRef,
    theme: theme,
    buttonType: _theme === 'v2' ? 'tertiary' : 'primary'
  }, closeButtonProps), closeButtonLabel);

  /* istanbul ignore next */
  var handleTouchStart = function (evt) {
    /* istanbul ignore next */
    if (!startY && !startX) {
      var firstTouch = evt.changedTouches[0];
      startY = firstTouch.pageY;
      startX = firstTouch.pageX;
    }
  };
  /* istanbul ignore next */


  var handleTouchEnd = function (evt) {
    var endTouch = evt.changedTouches[0];
    var endX = endTouch.pageX;
    var endY = endTouch.pageY;
    var xDiff = startX - endX;
    var yDiff = startY - endY;

    if (Math.abs(yDiff) > Math.abs(xDiff)) {
      // means up/down is most significant
      if (yDiff < 0) {
        // swipe down
        handleClose(evt, 'swipeDown');
      }
    }

    startX = null;
    startY = null;
  };

  var titleId = "header_".concat(idBase);
  var ariaProps = {
    role: 'dialog',
    className: wrapperClasses,
    'aria-modal': 'true',
    'aria-hidden': ariaHidden
  };

  if (hideTitle) {
    ariaProps['aria-label'] = title;
  } else {
    ariaProps['aria-labelledby'] = titleId;
  } // If there's a close button, we need to have an action zone even if there's nothing in it
  // Same for close button. Need to have an empty div if there's something in the action
  // But if neither is present, we want to give the whole space to the title.


  var emptyCloseButtonZone = action ? /*#__PURE__*/React.createElement("div", {
    className: styles['ppvx_modal-header__close']
  }) : null;
  var emptyActionZone = closeButtonTag ? /*#__PURE__*/React.createElement("div", {
    className: styles['ppvx_modal-header__action']
  }) : null; // Now that we've decided what the empty states would look like, decide if they're actually empty or not

  var closeButtonZone = closeButtonTag ? /*#__PURE__*/React.createElement("div", {
    className: styles['ppvx_modal-header__close']
  }, closeButtonTag) : emptyCloseButtonZone;
  var actionZone = action ? /*#__PURE__*/React.createElement("div", {
    className: styles['ppvx_modal-header__action'],
    ref: actionZoneRef
  }, action) : emptyActionZone;
  var headerContentZone = headerContents ? /*#__PURE__*/React.createElement("div", {
    className: styles['ppvx_modal-header__work-area'],
    ref: headerContentRef
  }, headerContents) : null;
  var header = showHeader ? /*#__PURE__*/React.createElement("header", {
    className: clsx(styles['ppvx_modal-header'], (_clsx4 = {}, _defineProperty(_clsx4, styles['ppvx_modal-header--scrolled'], headerScroll), _defineProperty(_clsx4, styles['ppvx_modal-header--divider'], divider), _clsx4), headerClassName),
    onTouchStart: handleTouchStart,
    onTouchMove: function handleTouchMove(evt) {
      // Prevent from scrolling
      evt.preventDefault();
    },
    onTouchEnd: handleTouchEnd
  }, actionZone, /*#__PURE__*/React.createElement("div", {
    className: styles['ppvx_modal-header__title'],
    id: titleId
  }, !hideTitle && title), closeButtonZone, headerContentZone) : null;
  var footer = footerContents ? /*#__PURE__*/React.createElement("footer", {
    className: clsx(styles['ppvx_modal-footer'], (_clsx5 = {}, _defineProperty(_clsx5, styles['ppvx_modal-footer--scrolled'], footerScroll), _defineProperty(_clsx5, styles["ppvx_modal-footer--align_".concat(footerAlign)], footerAlign), _clsx5), footerClassName)
  }, footerContents) : null;
  return /*#__PURE__*/React.createElement("div", ariaProps, /*#__PURE__*/React.createElement(FocusOn, {
    enabled: !isHidden // @ts-ignore: onEscapeKey() wants an Event, but the rest of this code wants SyntheticEvent<>
    ,
    onEscapeKey: function handleEscape(evt) {
      evt.preventDefault();
      handleClose(evt, 'ESC');
    },
    onClickOutside: function handleBackdropClick(evt) {
      handleClose(evt, 'backdropClick');
    },
    returnFocus: returnFocusToTrigger,
    className: styles['ppvx_modal--container_bottom']
  }, /*#__PURE__*/React.createElement("article", _extends({
    className: classes
  }, rest, {
    ref: sheetRef
  }), header, /*#__PURE__*/React.createElement("section", {
    className: contentClasses,
    onScroll: function handleScroll() {
      /* istanbul ignore else */
      if (contentRef && contentRef.current) {
        var contents = contentRef.current;
        /* istanbul ignore else */

        if (onContentScroll) {
          onContentScroll(contents.scrollTop);
        }
      }

      scrollCheck();
    },
    ref: contentRef
  }, children), footer)));
};

var _excluded$1 = ["isOpen", "onOpen", "onClose", "onCloseComplete", "containerRef"];

var Sheet = function (_ref) {
  var isOpen = _ref.isOpen,
      onOpen = _ref.onOpen,
      onClose = _ref.onClose,
      _ref$onCloseComplete = _ref.onCloseComplete,
      onCloseComplete = _ref$onCloseComplete === void 0 ? onClose : _ref$onCloseComplete,
      containerRef = _ref.containerRef,
      componentProps = _objectWithoutProperties(_ref, _excluded$1);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isMounted = _useState2[0],
      setIsMounted = _useState2[1];

  useEffect(function () {
    setIsMounted(true);
  }, []);
  var contents = /*#__PURE__*/React.createElement(Animator, {
    shouldHide: !isOpen,
    onOpen: onOpen,
    onCloseComplete: onCloseComplete
  }, function animatee(props) {
    return /*#__PURE__*/React.createElement(SheetComponent, _extends({}, props, componentProps));
  });
  var containerElm = containerRef && containerRef.current; // Delay createPortal until component is mounted to fix server side rendering

  return isMounted && ReactDOM.createPortal(contents, containerElm || document.body);
};

export { Sheet };
